import { render, staticRenderFns } from "./RegisterMain.vue?vue&type=template&id=e13841c4"
import script from "./RegisterMain.vue?vue&type=script&lang=js"
export * from "./RegisterMain.vue?vue&type=script&lang=js"
import style0 from "./RegisterMain.vue?vue&type=style&index=0&id=e13841c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports